import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-[#86868B] hover:text-[#1D1D1F] transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <div className="mt-6 bg-white rounded-2xl border border-[#E5E5EA] p-6 sm:p-8 space-y-6">
          <img src="/images/mib-logo-full.png" alt="MIB Logo" className="h-12 w-auto object-contain" />
          <h1 className="text-2xl sm:text-3xl font-bold text-[#1D1D1F]">Datenschutzerklärung</h1>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">1. Verantwortliche Stelle</h2>
            <p>Make It Media GmbH, Im Kohnental 2, 52353 Düren</p>
            <p>Vertreten durch: Celina Geraldes</p>
            <p>Telefon: +49 1573 3176758</p>
            <p>E-Mail: service@makeit-media.de</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
            <p>
              Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung unserer Website
              und unserer Dienstleistungen erforderlich ist. Dazu können insbesondere gehören:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Kontaktdaten (Name, E-Mail, Telefon) von Nutzern und Kunden</li>
              <li>Nutzungsdaten (Anmeldung, Buchungen, Kalender)</li>
              <li>Kommunikationsinhalte (E-Mails, SMS)</li>
              <li>Gesundheits- und Behandlungsdaten, soweit diese durch einen Standort in Kundenakten, Anamnesen, Behandlungsdokumentationen, GOÄ-Vorlagen oder Patientenrechnungen verarbeitet werden</li>
              <li>Nutzerinhalte wie Vorher-/Nachher-Fotos, Dokumente und Formulare</li>
              <li>Vertragsbezogene und Zahlungsdaten</li>
              <li>Technische Daten (IP-Adresse, Geräteinformationen, Push-Token, App-Version und Logs)</li>
            </ul>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">3. Zwecke und Rechtsgrundlagen</h2>
            <p>Die Verarbeitung erfolgt insbesondere auf Basis von Art. 6 Abs. 1 lit. a, b, c und f DSGVO:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>zur Vertragserfüllung und zur Durchführung vorvertraglicher Maßnahmen,</li>
              <li>zur Erfüllung gesetzlicher Pflichten,</li>
              <li>auf Grundlage Ihrer Einwilligung,</li>
              <li>auf Grundlage berechtigter Interessen (z. B. Sicherheit und technische Stabilität).</li>
            </ul>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4. Eingesetzte Dienste und Drittanbieter</h2>
            <p>Zur Bereitstellung von Make It Booking nutzen wir folgende Dienste:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Supabase</strong> (Auth, Datenbank, Speicher): Authentifizierung, Speicherung von Nutzer- und Buchungsdaten. Für dieses Projekt wird Supabase in der Region EU West (Frankfurt) betrieben. Anbieter: Supabase Inc., USA. Datenschutz: <a className="text-[#0071E3] hover:underline" href="https://supabase.com/privacy" target="_blank" rel="noreferrer">supabase.com/privacy</a></li>
              <li><strong>Stripe</strong>: Zahlungsabwicklung, Abonnements. Anbieter: Stripe Inc., USA. Datenschutz: <a className="text-[#0071E3] hover:underline" href="https://stripe.com/de/privacy" target="_blank" rel="noreferrer">stripe.com/de/privacy</a></li>
              <li><strong>Twilio</strong>: SMS-Versand (Erinnerungen, Bestätigungen). Anbieter: Twilio Inc., USA. Datenschutz: <a className="text-[#0071E3] hover:underline" href="https://www.twilio.com/legal/privacy" target="_blank" rel="noreferrer">twilio.com/legal/privacy</a></li>
              <li><strong>Google</strong>: Kalender-Synchronisation (Google Calendar API). Anbieter: Google LLC, USA. Datenschutz: <a className="text-[#0071E3] hover:underline" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">policies.google.com/privacy</a></li>
              <li><strong>Meta / Instagram</strong> (Instagram Graph API): Empfang und automatische Beantwortung von Instagram-Direktnachrichten und -Kommentaren sowie Darstellung im Messenger-Postfach, sofern ein Standort seinen Instagram-Business- oder -Creator-Account verbindet. Anbieter: Meta Platforms Ireland Ltd., Irland. Datenschutz: <a className="text-[#0071E3] hover:underline" href="https://privacycenter.instagram.com/policy" target="_blank" rel="noreferrer">privacycenter.instagram.com/policy</a></li>
              <li><strong>E-Mail-Versand</strong> (Resend o. ä.): Transaktionale E-Mails (Bestätigungen, Erinnerungen, Marketing).</li>
              <li><strong>Expo Push Service sowie Apple Push Notification Service und Firebase Cloud Messaging</strong>: Zustellung von mobilen Benachrichtigungen an registrierte Geräte. Dabei werden Push-Token, Geräteplattform und die für die Benachrichtigung erforderlichen Inhalte verarbeitet.</li>
            </ul>
            <p>Eine Übermittlung in Drittländer erfolgt nur auf Grundlage von Standardvertragsklauseln oder Angemessenheitsbeschlüssen.</p>
            <p>
              Soweit technisch möglich und für dieses Projekt eingerichtet, erfolgt die Speicherung der Anwendungsdaten über eine Supabase-Datenbank in einer europäischen Region, um datenschutzrechtliche Anforderungen und kurze Verarbeitungswege zu unterstützen.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4a. Verarbeitung von Google-Nutzerdaten</h2>
            <p>
              Wenn Sie die Google-Kalender-Synchronisation aktiv nutzen, verarbeitet Make It Booking Google-Nutzerdaten
              ausschließlich, um die Verbindung mit Ihrem Google-Konto herzustellen, Kalenderinformationen abzugleichen
              und Termine zwischen Make It Booking und Google Kalender anzuzeigen oder zu synchronisieren.
            </p>
            <p>Je nach Nutzung können dabei insbesondere folgende Google-Nutzerdaten verarbeitet werden:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Google-Konto-bezogene Verbindungsdaten im Rahmen der OAuth-Freigabe,</li>
              <li>Kalender-Metadaten und Kalender-IDs,</li>
              <li>Terminbezogene Kalenderdaten wie Titel, Datum, Uhrzeit und Status,</li>
              <li>technische Verbindungs- und Synchronisationsinformationen.</li>
            </ul>
            <p>
              Google-Nutzerdaten werden nicht verkauft und nicht für Werbezwecke, Profilbildung,
              personalisierte Werbung oder Datenhandel verwendet.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4b. Offenlegung und Weitergabe von Google-Nutzerdaten</h2>
            <p>
              Google-Nutzerdaten werden nur offengelegt oder übertragen, soweit dies zur Bereitstellung der
              Google-Kalender-Funktion technisch erforderlich ist oder eine gesetzliche Verpflichtung besteht.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Google LLC</strong> zur Authentifizierung, Autorisierung und Kalender-Synchronisation über die Google Calendar API,</li>
              <li><strong>eingesetzte Auftragsverarbeiter und Hosting-/Infrastruktur-Dienstleister</strong>, soweit dies für den technischen Betrieb, die sichere Speicherung oder die Synchronisation der Verbindung erforderlich ist,</li>
              <li><strong>Behörden oder sonstige empfangsberechtigte Stellen</strong>, wenn wir hierzu gesetzlich verpflichtet sind.</li>
            </ul>
            <p>
              Eine darüber hinausgehende Weitergabe von Google-Nutzerdaten an Dritte erfolgt nicht.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4c. Schutzmaßnahmen für personenbezogene und sensible Daten</h2>
            <p>
              Wir treffen angemessene technische und organisatorische Maßnahmen, um personenbezogene und sensible Daten
              vor unbefugtem Zugriff, Verlust, Manipulation oder Offenlegung zu schützen.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>verschlüsselte Datenübertragung über aktuelle HTTPS-/TLS-Verbindungen,</li>
              <li>Zugriffsbeschränkungen nach Rollen und Berechtigungen,</li>
              <li>beschränkter Zugriff auf Systeme und administrative Oberflächen nur für autorisierte Personen,</li>
              <li>Speicherung und Verarbeitung von Verbindungs- und Authentifizierungsdaten nur, soweit für den Betrieb erforderlich,</li>
              <li>Protokollierung technischer Vorgänge zur Fehleranalyse, Stabilität und Missbrauchserkennung,</li>
              <li>regelmäßige Überprüfung und Aktualisierung der Sicherheitsmaßnahmen.</li>
            </ul>
            <p>
              Soweit externe Dienstleister eingesetzt werden, wählen wir diese sorgfältig aus und binden sie,
              soweit erforderlich, vertraglich nach den datenschutzrechtlichen Vorgaben ein.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4d. Verarbeitung von Instagram-/Meta-Nutzerdaten</h2>
            <p>
              Wenn ein Standort seinen Instagram-Business- oder -Creator-Account mit Make It Booking verbindet,
              verarbeiten wir über die offiziellen Meta-Schnittstellen (Instagram Graph API) Instagram-Nutzerdaten
              ausschließlich, um automatische Antworten auf Instagram-Direktnachrichten und -Kommentare zu ermöglichen,
              Konversationen im Messenger-Postfach darzustellen und Instagram-Kontakte einem Kundenprofil zuzuordnen.
            </p>
            <p>Je nach Nutzung können dabei insbesondere folgende Instagram-/Meta-Nutzerdaten verarbeitet werden:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Instagram-Konto-bezogene Verbindungsdaten im Rahmen der OAuth-Freigabe (Zugriffstoken, Instagram-Konto-ID, Nutzername, Profilbild),</li>
              <li>Inhalte und Metadaten von Direktnachrichten (Text, Zeitpunkt, Absender- und Empfänger-Kennung),</li>
              <li>Inhalte und Metadaten von Kommentaren zu Beiträgen,</li>
              <li>daraus abgeleitete Automations- und Zustellungsereignisse (z. B. gesendet, gelesen, Klick).</li>
            </ul>
            <p>
              Instagram-/Meta-Nutzerdaten werden nicht verkauft und nicht für Werbezwecke, Profilbildung,
              personalisierte Werbung oder Datenhandel verwendet. Zugriffstokens werden verschlüsselt gespeichert.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4e. Offenlegung und Weitergabe von Instagram-/Meta-Nutzerdaten</h2>
            <p>
              Instagram-/Meta-Nutzerdaten werden nur offengelegt oder übertragen, soweit dies zur Bereitstellung der
              Instagram-Funktionen technisch erforderlich ist oder eine gesetzliche Verpflichtung besteht.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Meta Platforms Ireland Ltd.</strong> zur Authentifizierung, Autorisierung sowie zum Empfang und Versand von Nachrichten und Kommentaren über die Instagram Graph API,</li>
              <li><strong>eingesetzte Auftragsverarbeiter und Hosting-/Infrastruktur-Dienstleister</strong>, soweit dies für den technischen Betrieb, die sichere Speicherung oder die Verarbeitung erforderlich ist,</li>
              <li><strong>Behörden oder sonstige empfangsberechtigte Stellen</strong>, wenn wir hierzu gesetzlich verpflichtet sind.</li>
            </ul>
            <p>Eine darüber hinausgehende Weitergabe von Instagram-/Meta-Nutzerdaten an Dritte erfolgt nicht.</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4f. Widerruf und Löschung von Instagram-Daten</h2>
            <p>
              Sie können die Instagram-Verbindung jederzeit widerrufen. Dabei werden die bei uns gespeicherten
              Zugriffstokens entfernt und laufende Automationen gestoppt:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>in Make It Booking unter <strong>Marketing → Automationen → „Verbindung trennen"</strong>,</li>
              <li>alternativ direkt in Instagram unter <strong>Einstellungen → Apps und Websites</strong>, indem Sie den Zugriff der App entziehen.</li>
            </ul>
            <p>
              Anfragen zur Löschung Ihrer bei uns gespeicherten Instagram-Daten können Sie zudem jederzeit an{" "}
              <a className="text-[#0071E3] hover:underline" href="mailto:service@makeit-media.de">service@makeit-media.de</a>{" "}
              richten. Von Meta übermittelte Widerrufs- und Datenlöschungsanfragen verarbeiten wir zusätzlich
              automatisiert über die dafür vorgesehenen Endpunkte und entfernen die betroffenen Zugriffstokens und
              Verbindungsdaten.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4g. Mobile App und Benachrichtigungen</h2>
            <p>
              In der mobilen Make It Booking App werden Anmeldedaten sicher auf dem Gerät gespeichert. Kamera und
              Fotomediathek werden nur nach einer Gerätefreigabe verwendet, wenn Nutzer Behandlungsbilder aufnehmen
              oder auswählen. Push-Benachrichtigungen werden erst nach Einwilligung aktiviert und können in der App
              sowie in den Geräteeinstellungen deaktiviert werden.
            </p>
            <p>
              Benachrichtigungen können Informationen zu Terminen, Nachrichten, Formularen oder Zahlungen enthalten.
              Die Übertragung erfolgt über die Push-Dienste des jeweiligen Betriebssystems und den Expo Push Service.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">5. Speicherdauer</h2>
            <p>
              Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Zwecke
              erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Nach Vertragsende
              werden Daten gelöscht oder anonymisiert, sofern keine Aufbewahrungspflicht entgegensteht.
            </p>
            <p>
              Google-Nutzerdaten und Verbindungsinformationen speichern wir nur so lange, wie dies für die
              aktive Nutzung der Google-Kalender-Synchronisation, die Vertragserfüllung oder gesetzliche
              Aufbewahrungspflichten erforderlich ist. Wenn eine Google-Verbindung getrennt wird oder die
              Daten für diesen Zweck nicht mehr benötigt werden, werden sie gelöscht oder die weitere
              Verarbeitung eingeschränkt, soweit keine gesetzlichen Pflichten entgegenstehen.
            </p>
            <p>
              Instagram-Verbindungsdaten und Zugriffstokens speichern wir nur so lange, wie die Instagram-Verbindung
              aktiv genutzt wird. Wird die Verbindung getrennt oder der Zugriff widerrufen, werden die Zugriffstokens
              entfernt. Nachrichten- und Kommentarinhalte werden im Rahmen der Postfach- und CRM-Funktion gespeichert
              und gelöscht oder in der Verarbeitung eingeschränkt, sobald sie für diesen Zweck nicht mehr erforderlich
              sind oder Sie die Löschung verlangen, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">6. Cookies und Tracking</h2>
            <p>
              Wir verwenden technisch notwendige Cookies, um die Funktionalität und Sicherheit der Website
              sicherzustellen (z. B. Session-Verwaltung, Authentifizierung). Darüber hinaus setzen wir
              keine Tracking-Technologien ein, es sei denn, Sie haben dem zugestimmt oder es besteht
              eine entsprechende Rechtsgrundlage.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">7. Ihre Rechte</h2>
            <p>Sie haben insbesondere folgende Rechte gemäß DSGVO:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Auskunft über gespeicherte Daten (Art. 15 DSGVO),</li>
              <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO),</li>
              <li>Löschung oder Einschränkung der Verarbeitung (Art. 17, 18 DSGVO),</li>
              <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO),</li>
              <li>Datenübertragbarkeit (Art. 20 DSGVO),</li>
              <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO).</li>
            </ul>
            <p>
              Eine Kontolöschung kann in der mobilen App unter <strong>Einstellungen → Rechtliches & Konto</strong>
              beantragt werden. Weitere Informationen und eine alternative Kontaktmöglichkeit finden Sie unter{" "}
              <Link className="text-[#0071E3] hover:underline" to="/konto-loeschen">Konto löschen lassen</Link>.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">8. Kontakt</h2>
            <p>
              Bei Fragen zum Datenschutz können Sie uns jederzeit unter{" "}
              <a className="text-[#0071E3] hover:underline" href="mailto:service@makeit-media.de">
                service@makeit-media.de
              </a>{" "}
              kontaktieren.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
